


  "use client"
import type React from "react"
import { useState, useEffect } from "react"
import { useParams, useLocation, useHistory, Link } from "react-router-dom"
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonLoading,
  IonButton,
} from "@ionic/react"
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  Grid,
  Button,
  Stack,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Divider,
  Paper,
} from "@mui/material"
import {
  Work as WorkIcon,
  Person as PersonIcon,
  LocationOn as LocationIcon,
  AttachMoney as MoneyIcon,
  Schedule as ScheduleIcon,
  Language as LanguageIcon,
  School as SchoolIcon,
  Business as BusinessIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material"
import { styled } from "@mui/material/styles"
import { getProjectDetail } from "../../../api/projects/project"
import { formatToNaira } from "../../../common/utils_t"
import { Calendar, Calendar1Icon } from "lucide-react"
// import { getProjectDetail } from "../../../api/projects/project"
// import { getProjectDetail } from "../../api/projects/project"

interface JobRole {
  jobrole_id: string
  job_title: string
  employment_type: string
  field_of_study: string
  job_function: string
  minsalary: string
  maxsalary: string
  skills: string
  languages_spoken: string
  location: string
  availability: string
  work_authorization: string
  level_of_education: string
  total_year_of_experience: number
  number_required: string
  preferred_industries: string
  previous_industries: string
  certificate_qualification: string
  remote_work_preference: string
  willing_to_relocate: string
}

interface Project {
  project_id: string
  project_name: string
  status: string
  user_id: string
  job_roles: JobRole[]
}

const StyledCard = styled(Card)(({ theme }) => ({
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[8],
  },
  height: "100%",
}))

const StatusChip = styled(Chip)<{ status: string }>(({ theme, status }) => {
  const getStatusColor = () => {
    switch (status) {
      case "PENDING":
        return { backgroundColor: theme.palette.warning.main, color: "white" }
      case "IN_PROGRESS":
        return { backgroundColor: theme.palette.primary.main, color: "white" }
      case "COMPLETED":
        return { backgroundColor: theme.palette.success.main, color: "white" }
      default:
        return { backgroundColor: theme.palette.grey[500], color: "white" }
    }
  }
  return {
    ...getStatusColor(),
    fontWeight: 600,
    fontSize: "0.75rem",
  }
})

const ATSProjectDetail: React.FC = () => {
  // const { projectId } = useParams<{ projectId: string }>()
  
  const location = useLocation()
   const history = useHistory()
  const segment = location.pathname.split('/')
  const projectId = segment[3]

  const [project, setProject] = useState<Project | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [selectedJobRole, setSelectedJobRole] = useState<JobRole | null>(null)
  const [showJobRoleModal, setShowJobRoleModal] = useState(false)

  useEffect(() => {
    if (projectId) {
      fetchProjectData();

    }
  }, [projectId])

  const fetchProjectData = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await getProjectDetail(projectId!)
      console.log(response)
      
      setProject(response.data)
    } catch (error) {
      console.error("Error fetching project data:", error)
      setError("Failed to load project data. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const handleJobRoleClick = (jobRole: JobRole) => {
    setSelectedJobRole(jobRole)
    setShowJobRoleModal(true)
  }

  const handleViewApplicants = (jobRoleId: string) => {
    console.log({jobRoleId})
    // history.push(`/folder/projects/${projectId}/jobs/${jobRoleId}/applicants`)
        history.push(`/folder/projects/${project.project_id}/${jobRoleId}`)

  }

  // const formatSalary = () => {
  //   return `$${Number.parseFloat(min).toLocaleString()} - $${Number.parseFloat(max).toLocaleString()}`
  // }
 {console.log(project)}
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/projects" />
          </IonButtons>
          <IonTitle>Project Details</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Box sx={{ p: 3 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          {project && (
            <>
              <Paper elevation={2} sx={{ p: 3, mb: 4, borderRadius: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                  <Avatar sx={{ bgcolor: "primary.main", width: 56, height: 56 }}>
                    <BusinessIcon fontSize="large" />
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h4" fontWeight="700" gutterBottom>
                      {project.project_name}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography variant="body1" color="text.secondary">
                        ID: {project.project_id}
                      </Typography>
                      <StatusChip label={project.status} status={project.status} />
                    </Box>
  <Link
  to={{
    pathname: "/folder/projectDetail",
    search: `?id=${project.project_id}`,
    state: { project }, // ✅ Correct place
  }}
>
  <IonButton>
    Manage Job Application Links
   
  </IonButton>
</Link>


                   </Box>
                </Box>
                <Typography variant="body1" color="text.secondary">
                  User ID: {project.user_id}
                </Typography>
              </Paper>

              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <WorkIcon color="primary" />
                  Job Roles ({project.job_roles?.length || 0})
                </Typography>
              </Box>
 
              {project.job_roles && project.job_roles.length > 0 ? (
                <Grid container spacing={3}>
                  {project.job_roles.map((jobRole) => (
                    <Grid item xs={12} md={6} lg={4} key={jobRole.jobrole_id}>
                      <StyledCard onClick={() => handleJobRoleClick(jobRole)}>
                        <CardHeader
                          avatar={
                            <Avatar sx={{ bgcolor: "secondary.main" }}>
                              <WorkIcon />
                            </Avatar>
                          }
                          title={
                            <Typography variant="h6" fontWeight="600">
                              {jobRole.job_title}
                            </Typography>
                          }
                          subheader={jobRole.employment_type}
                        />
                        <CardContent sx={{ pt: 0 }}>
                          <Stack spacing={2}>
                            <Box>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <MoneyIcon fontSize="small" color="success" />
                                <Typography variant="body2" fontWeight="600" color="success.main">
                                  {formatToNaira(jobRole.budget) || "Not Specified"}
                                </Typography>
                              </Stack>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <LocationIcon fontSize="small" color="action" />
                                <Typography variant="body2" color="text.secondary">
                                  {jobRole.location},    {jobRole.nationality}
                                </Typography>
                              </Stack>
                              
                              
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <PersonIcon fontSize="small" color="action" />
                                <Typography variant="body2" color="text.secondary">
                                  {jobRole.number_required} positions
                                </Typography>
                              </Stack>


                            </Box>
           
               
       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
 <Avatar
  sx={{
    bgcolor: (theme) => [
      theme.palette.warning.main,
      theme.palette.error.light,
      theme.palette.success.light,
      theme.palette.info.main,
      theme.palette.secondary.main,
      '#FF6B35',
      '#FF8E53',
      '#FFB238',
    ][jobRole.id % 8],
    width: 23,
    height: 17,
    fontSize: "12px",
    fontWeight: 700,
    boxShadow: (theme) => `0 4px 12px ${theme.palette.warning.main}30`,
  }}
>
  {jobRole.application_count}
</Avatar>

  <Typography variant="body2" sx={{ fontWeight: 600 }}>
    applicants
  </Typography>
</Box>
                            <Box>

                                 <Stack direction="row" alignItems="center" spacing={1}>
                                <Calendar fontSize="small" color="black" />
                                <Typography variant="body2" color="text.secondary">
                                  {jobRole.created_at} 
                                </Typography>
                              </Stack>
                              
                            </Box>

                            <Button
                              variant="contained"
                              color="primary"
                              fullWidth
                              startIcon={<PersonIcon />}
                              onClick={(e) => {
                                e.stopPropagation()
                                handleViewApplicants(jobRole.jobrole_id)
                              }}
                              sx={{ mt: 2 }}
                            >
                              View Applicants
                            </Button>
                          </Stack>
                        </CardContent>
                      </StyledCard>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Paper sx={{ p: 6, textAlign: "center", borderRadius: 3 }}>
                  <WorkIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    No Job Roles Found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    This project doesn't have any job roles yet.
                  </Typography>
                </Paper>
              )}
            </>
          )}

          <Dialog
            open={showJobRoleModal}
            onClose={() => setShowJobRoleModal(false)}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}
          >
            {selectedJobRole && (
              <>
                <DialogTitle sx={{ pb: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48 }}>
                      <WorkIcon />
                    </Avatar>
                    <Box>
                      <Typography variant="h5" fontWeight="600">
                        {selectedJobRole.job_title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {selectedJobRole.employment_type}
                      </Typography>
                    </Box>
                  </Box>
                </DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={2}>
                        <Box>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            gutterBottom
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <MoneyIcon fontSize="small" />
                            Compensation
                          </Typography>
                          <Typography variant="h6" color="success.main" fontWeight="600">
                            {formatToNaira(selectedJobRole.minsalary, selectedJobRole.maxsalary)}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            gutterBottom
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <LocationIcon fontSize="small" />
                            Location & Work
                          </Typography>
                          <Typography variant="body2">{selectedJobRole.location}</Typography>
                          {selectedJobRole.remote_work_preference && (
                            <Typography variant="body2" color="text.secondary">
                              Remote: {selectedJobRole.remote_work_preference}
                            </Typography>
                          )}
                          {selectedJobRole.willing_to_relocate && (
                            <Typography variant="body2" color="text.secondary">
                              Willing to relocate: {selectedJobRole.willing_to_relocate}
                            </Typography>
                          )}
                        </Box>

                        <Box>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            gutterBottom
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <ScheduleIcon fontSize="small" />
                            Availability
                          </Typography>
                          <Typography variant="body2">{selectedJobRole.availability}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Authorization: {selectedJobRole.work_authorization}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Stack spacing={2}>
                        <Box>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            gutterBottom
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <SchoolIcon fontSize="small" />
                            Education & Experience
                          </Typography>
                          <Typography variant="body2">{selectedJobRole.level_of_education}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Field: {selectedJobRole.field_of_study}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Experience: {selectedJobRole.total_year_of_experience} years
                          </Typography>
                          {selectedJobRole.certificate_qualification && (
                            <Typography variant="body2" color="text.secondary">
                              Certifications: {selectedJobRole.certificate_qualification}
                            </Typography>
                          )}
                        </Box>

                        <Box>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            gutterBottom
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <LanguageIcon fontSize="small" />
                            Languages
                          </Typography>
                          <Typography variant="body2">{selectedJobRole.languages_spoken}</Typography>
                        </Box>

                        <Box>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            gutterBottom
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <BusinessIcon fontSize="small" />
                            Industry
                          </Typography>
                          <Typography variant="body2">Preferred: {selectedJobRole.preferred_industries}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            Previous: {selectedJobRole.previous_industries}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    <Grid item xs={12}>
                      <Divider sx={{ my: 2 }} />
                      <Box>
                        <Typography
                          variant="subtitle2"
                          color="primary"
                          gutterBottom
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <AssignmentIcon fontSize="small" />
                          Job Function & Skills
                        </Typography>
                        <Typography variant="body2" paragraph>
                          {selectedJobRole.job_function}
                        </Typography>
                        <Typography variant="body2" fontWeight="500" gutterBottom>
                          Required Skills:
                        </Typography>
                        {/* <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          {selectedJobRole?.skills.split(",")?.map((skill, index) => (
                            <Chip key={index} label={skill.trim()} size="small" variant="outlined" />
                          ))}
                        </Box> */}
                      </Box>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 3 }}>
                  <Button onClick={() => setShowJobRoleModal(false)} variant="outlined">
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<PersonIcon />}
                    onClick={() => {
                      setShowJobRoleModal(false)
                      handleViewApplicants(selectedJobRole.jobrole_id)
                    }}
                  >
                    View Applicants
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>
        </Box>
        <IonLoading isOpen={loading} message="Loading project details..." />
      </IonContent>
    </IonPage>
  )
}

export default ATSProjectDetail
